export default __webpack_public_path__ + "static/media/bronze.483fe8ef.svg";